import React from 'react'

import ButtonContainer from 'components/Template/Creation/ButtonContainer'

import { StyledContainer, StyledForm } from 'styles/creation'

import SliderContainer, { SliderProps } from '../SliderContainer'

export type ExtendedSliderProps = {
  id: string | number
  max?: number
} & SliderProps

type Props = {
  handleBack: () => void
  handleNext: () => void
  sliderItems: ExtendedSliderProps[]
}

const Skeleton = ({ handleBack, handleNext, sliderItems }: Props) => {
  return (
    <StyledContainer>
      <StyledForm>
        <div>
          {sliderItems.map((item) => (
            <SliderContainer
              key={item.name}
              title={item.title}
              name={item.name}
              info={item.info}
              max={item.max}
              setInfo={item.setInfo}
              handleInputChange={item.handleInputChange}
              handleBlur={item.handleBlur}
            />
          ))}
        </div>
      </StyledForm>
      <ButtonContainer
        previousFunction={handleBack}
        nextFunction={handleNext}
      />
    </StyledContainer>
  )
}

export default Skeleton
